<template>
    <div id="dlXlsx">
        <!-- <el-button type="primary" @click="setXlsx(sheet, head, data)">下载数据</el-button> -->
        <!-- <span class="downEx" style="cursor: pointer;" @click="setXlsx(sheet, head, data)">导出表格</span> -->
        <span class="downEx" style="cursor: pointer;" @click="downData(livingId, bmbm, livetype)">导出表格</span>
    </div>
</template>

<script>
import xlsx from '@/common/xlsx'
import model from '../../views/course/model/model'
import _ from 'lodash'
var that = null
export default {
    props: {
        livingId: {
            type: String,
        },
        bmbm: {
            type: String,
        },
        livetype: {
            type: String,
        },
        // sheet: {
        //     type: Array,
        // },
        // head: {
        //     type: Array,
        // },
        // data: {
        //     type: Array,
        // },
    },
    data() {
        that = this
        return {
            line: {
                down: {
                    sheet: ['员工数据'],
                    head: [],
                    list: [],
                },
            },
        }
    },
    methods: {
        downData(livingId, bmbm, livetype) {
            console.log(livingId, bmbm, livetype)
            let par = { livingid: livingId, bmbm: bmbm, livetype: livetype }
            model.e_live_bm_export(par).then(
                (res) => {
                    console.log(res)
                    that.line.down.head = [
                        '客户昵称',
                        '客户头像',
                        '是否新客户',
                        '是否退出',
                        '直播观看时长',
                        '回看时长',
                        '累计观看时长',
                        '第一次观看时间',
                        '首次进入时间',
                        '最近进入时间',
                        '评论数',
                    ]
                    that.line.down.list = res.list.map((v) => ({
                        wx_nickname: v.wx_nickname,
                        wx_avatar: v.wx_avatar,
                        user_x: v.user_x,
                        out: v.out == 1 ? '是' : '否',
                        his_learning_time:
                            Math.round(v.his_learning_time / 60) + '分钟',
                        his_learned_time:
                            Math.round(v.his_learned_time / 60) + '分钟',
                        his_learn_time:
                            Math.round(v.his_learn_time / 60) + '分钟',
                        first_min_time: v.first_min_time,
                        first_in_time: v.first_in_time,
                        last_in_time: v.last_in_time,
                        comment_num: v.comment_num,
                    }))
                    that.setXlsx(
                        that.line.down.sheet,
                        that.line.down.head,
                        that.line.down.list
                    )
                    // that.get_e_live_list()
                    // this.HideSetDate()
                },
                (error) => {
                    this.$message.error('获取导出数据异常！')
                }
            )
        },
        setXlsx(sheet, head, data) {
            var Sheets = [],
                List = [],
                Heads = [],
                li = [] // sheets工作簿 名称，list数据 对象数组，heads 头部标题
            Sheets.push(sheet)
            Heads.push(head)

            _.forEach(data, function (v) {
                var obj = new Object()
                obj = v
                li.push(obj)
            })
            List.push(li)

            var ExeclConfig = {
                SheetName: sheet,
                data: {
                    Head: Heads, // 头部标题 如只有一个 就全一样
                    Sheets: Sheets, //工作薄 名称
                    List: List, //数据 对象数组
                },
            }
            console.log(ExeclConfig)
            // return
            xlsx.toExecl(ExeclConfig)
        },
    },
}
</script>

<style>
</style>
